import { asyncTypes } from 'store/_helpers';

const TYPES = {
  ...asyncTypes('UPDATE_CLASSIFICATION_SOCIETY')
};

export default TYPES;
